export const IDX = {
    key: 0,
    equipmentId: 1,
    hoekverhouding: 2,
    profiel: 3,
    boogstraal: 4,
    smeerlozeConstructie: 5,
    wisselligger: 6,
    type: 7,
    geocode: 8,
    classificatie: 9,
    plaatsingsdatum: 10,
    tekeningnummer: 11,
    afschrijvingsgroep: 12,
    disabled: 13
};
export const loadItems = () => fetch(`${__webpack_public_path__}assets/prorail.json`)
    .then(r => r.json())
    .then(d => d.array);
